/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Collections_Tooltips_WeeksInputs */

const id_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jumlah minggu game tersebut berada di 100 besar untuk ${i?.title}.`)
};

const ms_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bilangan minggu permainan berada dalam 100 teratas untuk ${i?.title}.`)
};

const da_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Antallet af uger spillet har været i top 100 for ${i?.title}.`)
};

const de_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Anzahl der Wochen, die das Spiel in den Top 100 für ${i?.title} war.`)
};

const en_us2_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The number of weeks the game has been in the top 100 for ${i?.title}.`)
};

const es_es2_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El número de semanas que el juego ha estado en el top 100 de ${i?.title}.`)
};

const es_mx2_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El número de semanas que el juego ha estado en el top 100 de ${i?.title}.`)
};

const fil_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ang bilang ng mga linggo na ang laro ay nasa top 100 para sa ${i?.title}.`)
};

const fr_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le nombre de semaines où le jeu a été dans le top 100 pour ${i?.title}.`)
};

const it_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il numero di settimane in cui il gioco è stato nella top 100 per ${i?.title}.`)
};

const hu_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A hetek száma, amióta a játék a top 100-ban van a ${i?.title} kategóriában.`)
};

const nl_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Het aantal weken dat de game in de top 100 staat voor ${i?.title}.`)
};

const no_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Antall uker spillet har vært i topp 100 for ${i?.title}.`)
};

const pl_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Liczba tygodni, przez które gra znajdowała się w top 100 dla ${i?.title}.`)
};

const pt_br2_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O número de semanas que o jogo esteve entre os 100 primeiros para ${i?.title}.`)
};

const pt_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O número de semanas que o jogo esteve no top 100 para ${i?.title}.`)
};

const ro_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Numărul de săptămâni în care jocul a fost în top 100 pentru ${i?.title}.`)
};

const fi_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Niiden viikkojen määrä, joina peli on ollut top 100:ssa kohteelle ${i?.title}.`)
};

const sv_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Antalet veckor som spelet har funnits i topp 100 för ${i?.title}.`)
};

const vi_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số tuần game có mặt trong top 100 của ${i?.title}.`)
};

const tr_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oyunun ${i?.title} için ilk 100'de olduğu hafta sayısı.`)
};

const cs_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Počet týdnů, po které je hra v top 100 pro ${i?.title}.`)
};

const bg_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Броят седмици, в които играта е била в топ 100 за ${i?.title}.`)
};

const ru_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Количество недель, которые игра провела в ТОП-100 для ${i?.title}.`)
};

const uk_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Кількість тижнів, протягом яких гра була в топ-100 для ${i?.title}.`)
};

const ar_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عدد الأسابيع التي كانت فيها اللعبة ضمن أفضل 100 لـ ${i?.title}.`)
};

const hi_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} के लिए गेम टॉप 100 में रहने के सप्ताहों की संख्या।`)
};

const th_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`จำนวนสัปดาห์ที่เกมอยู่ใน 100 อันดับแรกสำหรับ ${i?.title}`)
};

const ja_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} でゲームがトップ100に入っている週数。`)
};

const zh_cn2_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`该游戏进入 ${i?.title} 前100名的周数。`)
};

const zh_hant1_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`該遊戲進入 ${i?.title} 前100名的週數。`)
};

const ko_collections_tooltips_weeks = /** @type {(inputs: Collections_Tooltips_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}에서 게임이 TOP 100에 있었던 주 수입니다.`)
};

/**
* | output |
* | --- |
* | "The number of weeks the game has been in the top 100 for {title}." |
*
* @param {Collections_Tooltips_WeeksInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_tooltips_weeks = /** @type {((inputs: Collections_Tooltips_WeeksInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Tooltips_WeeksInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_tooltips_weeks(inputs)
	if (locale === "ms") return ms_collections_tooltips_weeks(inputs)
	if (locale === "da") return da_collections_tooltips_weeks(inputs)
	if (locale === "de") return de_collections_tooltips_weeks(inputs)
	if (locale === "en-US") return en_us2_collections_tooltips_weeks(inputs)
	if (locale === "es-ES") return es_es2_collections_tooltips_weeks(inputs)
	if (locale === "es-MX") return es_mx2_collections_tooltips_weeks(inputs)
	if (locale === "fil") return fil_collections_tooltips_weeks(inputs)
	if (locale === "fr") return fr_collections_tooltips_weeks(inputs)
	if (locale === "it") return it_collections_tooltips_weeks(inputs)
	if (locale === "hu") return hu_collections_tooltips_weeks(inputs)
	if (locale === "nl") return nl_collections_tooltips_weeks(inputs)
	if (locale === "no") return no_collections_tooltips_weeks(inputs)
	if (locale === "pl") return pl_collections_tooltips_weeks(inputs)
	if (locale === "pt-BR") return pt_br2_collections_tooltips_weeks(inputs)
	if (locale === "pt") return pt_collections_tooltips_weeks(inputs)
	if (locale === "ro") return ro_collections_tooltips_weeks(inputs)
	if (locale === "fi") return fi_collections_tooltips_weeks(inputs)
	if (locale === "sv") return sv_collections_tooltips_weeks(inputs)
	if (locale === "vi") return vi_collections_tooltips_weeks(inputs)
	if (locale === "tr") return tr_collections_tooltips_weeks(inputs)
	if (locale === "cs") return cs_collections_tooltips_weeks(inputs)
	if (locale === "bg") return bg_collections_tooltips_weeks(inputs)
	if (locale === "ru") return ru_collections_tooltips_weeks(inputs)
	if (locale === "uk") return uk_collections_tooltips_weeks(inputs)
	if (locale === "ar") return ar_collections_tooltips_weeks(inputs)
	if (locale === "hi") return hi_collections_tooltips_weeks(inputs)
	if (locale === "th") return th_collections_tooltips_weeks(inputs)
	if (locale === "ja") return ja_collections_tooltips_weeks(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_tooltips_weeks(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_tooltips_weeks(inputs)
	return ko_collections_tooltips_weeks(inputs)
});
export { collections_tooltips_weeks as "collections.tooltips.weeks" }